var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHangUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_5142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5113 11.3986C23.0019 11.8447 23.2951 12.4674 23.3265 13.1297C23.3579 13.792 23.1249 14.4397 22.6788 14.9302L21.9095 15.776C21.4273 16.3062 20.6455 16.44 20.0142 16.1012L16.6678 14.3025C16.3969 14.157 16.175 13.9348 16.0298 13.6637C15.8846 13.3926 15.8227 13.0847 15.8517 12.7785L15.9787 11.4375C15.9921 11.2977 15.9171 11.1968 15.8323 11.1625C14.5696 10.6499 13.2106 10.4178 11.8494 10.4823C10.4882 10.5468 9.1572 10.9064 7.94868 11.5362C7.8675 11.5784 7.80296 11.6853 7.829 11.8239L8.08226 13.1469C8.14012 13.4489 8.10757 13.7613 7.98869 14.0449C7.86981 14.3285 7.66988 14.5707 7.41395 14.7412L4.25279 16.8484C3.65632 17.2454 2.86538 17.1862 2.33458 16.7034L1.48936 15.9347C0.998843 15.4886 0.705635 14.8659 0.674238 14.2036C0.642841 13.5413 0.875827 12.8936 1.32194 12.4031L2.5835 11.016C7.46039 5.65371 15.7619 5.26016 21.1242 10.1371L22.5113 11.3986Z",
    fill: "url(#paint0_linear_199_5142)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_199_5142",
    x1: 0.225833,
    y1: 26.6131,
    x2: 24.9468,
    y2: 25.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_5142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangUpIcon);
export default __webpack_public_path__ + "static/media/hang-up-icon.5e9eeee9aeec08a66c9bbfa03a5918ce.svg";
export { ForwardRef as ReactComponent };